
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerDocFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerDoc"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"filename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"s3Key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uploaded"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uploadedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uploadedById"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"verified"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"verifiedById"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":205}};
    doc.loc.source = {"body":"fragment CustomerDocFields on CustomerDoc {\n  id\n  filename\n  displayPath\n  s3Key\n  downloadUrl\n  uploaded\n  uploadedAt\n  uploadedById\n  verified\n  verifiedAt\n  verifiedById\n  tags\n  title\n  description\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragments/CustomerDocFragment.graphql
// module id = 94
// module chunks = 0